module.exports = __webpack_public_path__ + "media/images/logo-192x192-5da2a821486519f475ddf07ba8be2e42.png";